import { CSSResultGroup, html, css, TemplateResult, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

import { SlotController } from '../../controllers/slot-controller';

import componentStyles from './ghs-interior-hero.css.lit';
import '../../base/outline-container/outline-container';
import { GhsInPageHero } from '../ghs-in-page-hero/ghs-in-page-hero';

export type BackgroundColor = 'light-gray' | 'white';

/**
 * The ghs-interior-hero component.
 * @element ghs-interior-hero
 * @slot eyebrow - eyebrow text
 * @slot title - title text
 * @slot image - image
 * @slot body - ghs-styled-text body content
 *    - 'default' variant on dark-colored heros
 *    - 'dark' variant on light-colored heros
 * @slot cta-links - ghs-button CTA link list
 *    - 'tertiary' variant on light-colored heros
 *    - 'primary' variant on dark-colored heros
 */
@customElement('ghs-interior-hero')
export class GHSInteriorHero extends GhsInPageHero {
  static styles: CSSResultGroup = [componentStyles, css``];

  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html`
      <div class="interior-hero bg-${this.backgroundColor}">
        <outline-container x-padding>
          <div
            class="interior-hero-inner ${this.isFlipped ? 'is-flipped' : ''}"
          >
            ${this.hasImageSlot
              ? html`
                  <div
                    class="interior-hero-image ${this.isFlipped
                      ? 'margin-right'
                      : 'margin-left'}"
                  >
                    <slot name="image"></slot>
                  </div>
                `
              : nothing}
            <div class="interior-hero-content">
              ${this.hasEyebrowSlot
                ? html`
                    <div class="interior-hero-eyebrow">
                      <slot name="eyebrow"></slot>
                    </div>
                  `
                : nothing}
              ${this.hasTitleSlot
                ? html`
                    <div class="interior-hero-title">
                      <slot name="title"></slot>
                    </div>
                  `
                : nothing}
              ${this.hasBodySlot
                ? html`
                    <div class="interior-hero-body">
                      <slot name="body"></slot>
                    </div>
                  `
                : nothing}
              ${this.hasCtaLinksSlot
                ? html` <slot name="cta-links"></slot> `
                : nothing}
            </div>
          </div>
        </outline-container>
      </div>
    `;
  }
}
